<template>
	<sf-modal-layout :show="display" :title="saveInfo.title" :closeModal="closeModal" size="l">
		<el-row :gutter="24">
			<el-col class="ml-2" style="height: 500px">
				<excel-file-input @uploadExcel="uploadExcel" :initState="initState" :propError="errMsg"></excel-file-input>
			</el-col>
		</el-row>
		<el-row :gutter="24"> </el-row>
		<template v-slot:footer>
			<sf-button line :onClick="closeModal">
				{{ getMessage_('QWCC001971') }}
			</sf-button>
			<sf-button line :onClick="addAction" style="width: fit-content !important">
				{{ getMessage_('QWCC001488') }}
			</sf-button>
		</template>
	</sf-modal-layout>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { qmsComputed, qmsMethods } from '@/store/qms/helpers';
import ExcelFileInput from './ExcelFileInput.vue';
import * as yup from 'yup';

export default {
	props: {
		scrId: { type: String, default: '' } // 부모로부터 받는 데이터 정의
	},
	data() {
		//해당 컴포넌트안에서 사용하는 상태 정의(지역변수)
		return {
			initState: false, // excel-file-input 초기화여부
			display: false,
			saveInfo: {
				title: '', //엑셀업로드 팝업명()
				apiGubun: '', //업무테이블구분값
				flag: '', //I면 리스트 클리어 U면 기존 업로드된 리스트를 보여줌.
				fileList: [], //ExcelUpload.vue에서 파일첨부한 파일객체들 (엑셀업로드기때문에 단건에 대한 파일객체를 보여줌)}
				param1: ''
			},
			errMsg: '' // excel-file-input 표기할 에러메세지
		};
	},
	components: {
		ExcelFileInput
	},
	computed: {
		...rootComputed,
		...qmsComputed,
		schema() {
			return yup.object().shape({
				//URL체크 ARRAY 형식이 아닌 단독으로 VALIDATION 체크
				apiGubun: yup
					.string()
					.nullable()
					.required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('MWCC000737')])) //{0}은(는) 팔수 입력 값 입니다. , API URL
			});
		}
	},
	methods: {
		...rootMethods,
		...qmsMethods,

		open(param) {
			//받아온 파라미터로 팝업오픈상태와 팝업창 타이틀명 BE통신시(구분값을 던진다 ),flag:I면등록,U면수정
			this.display = this.initState = true;
			this.saveInfo.fileList = [];
			if (!this.$sf_isEmptyObj(param)) {
				this.saveInfo = { ...this.saveInfo, ...param };
			}
		},
		closeModal() {
			//닫기 버튼을 누를시 등록일경우에는 FileUpload.vue 리스트를 초기화한다.
			this.display = this.initState = false;
		},
		uploadExcel(file) {
			// ExcelFileUpload.vue에서 파일업로드를 하면 호출함.
			this.saveInfo.fileList[0] = file;
			this.initState = true;
		},
		addAction() {
			try {
				//엑셀업로드 업무구분값체크
				this.schema.validateSync({ apiGubun: this.saveInfo.apiGubun });

				//파일업로드된 파일명을 담고있는 list의 길이를 체크함.
				if (this.saveInfo.fileList.length === 0) {
					this.$sf_toast({ type: 'error', message: this.getMessage_('QWCC000928') }); //첨부파일을 등록해주세요.
					return false;
				}

				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					message: this.getMessage_('MWCC000555'), //저장하시겠습니까?
					buttons: [{ title: this.getMessage_('MWCC000502'), clickFn: this.uploadFile }] //추가
				});
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			}
		},

		async uploadFile() {
			this.$sf_toggleLoading(true);

			this.errMsg = '';
			const formData = new FormData();

			if (this.saveInfo.fileList.length > 0) this.saveInfo.fileList.forEach(element => formData.append('fileList', element));
			else formData.append('fileList', '');

			//폼객체에 API 구분값을 담는다.
			formData.append('apiGubun', this.saveInfo.apiGubun);
			formData.append('param1', this.saveInfo.param1);

			try {
				const { body, header } = await this.addExcelUpload_({ formData });
				if (header?.code === 0) {
					if (body?.tmpResultCd === 'E') {
						//올려진 엑셀안에 기등록건또는 엑셀에 필수값 등록이 안되어 있을경우 상태코드가 E로 떨어짐
						let rsltMsg = '';
						for (const msg of body.tmpExcelList) {
							rsltMsg += msg.RESULT_MSG + '\n\r';
						}
						this.errMsg = rsltMsg;
					} else if (body?.tmpResultCd === 'S') {
						// 업로드가 성공하면 알림창 호출
						this.$sf_toast({ type: 'ok', message: header.message });
						//파일리스트 초기화 및 팝업 닫는다.
						this.closeModal();
						this.$emit('Refresh');
					}
				} else {
					this.$sf_toast({ type: 'error', message: header.message });
				}
			} catch (error) {
				this.$sf_toast({ type: 'error', message: 'Sorry for internal error. Please check the file uploaded again.' }); //다국어 처리 필요
				this.errMsg = 'An Internal Server Error happend. Please Try Again.';
				return error;
			} finally {
				this.$sf_toggleLoading(false);
			}
		}
	}
};
</script>
